import { render, staticRenderFns } from "./Empresa.vue?vue&type=template&id=6861df74&scoped=true&"
import script from "./Empresa.vue?vue&type=script&lang=js&"
export * from "./Empresa.vue?vue&type=script&lang=js&"
import style0 from "./Empresa.vue?vue&type=style&index=0&id=6861df74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861df74",
  null
  
)

export default component.exports